import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=3ef6a6b8&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=3ef6a6b8&scoped=true&lang=scss&"
import style1 from "./Message.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6a6b8",
  null
  
)

export default component.exports